@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  display: block;
}

.spid-agid {
  max-height: 32px;
}

a {
  color: #06c;
}

a:hover {
  color: #0052a3;
}

.spid-cie-button {
  background-color: #06C;
  color: #FFF;
  border-radius: 5px;
  width: 250px;
  height: 46px;
  padding: 0;
  font-family: "Titillium Web", HelveticaNeue, Helvetica Neue, Helvetica,
  Arial, Lucida Grande, sans-serif;
  font-weight: 600;
  line-height: 1em;
  text-decoration: none;
  border: 0;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.spid-cie-button:hover {
  background-color: #036;
}

.cns-button {
  background-color: #2d7a3c;
  color: #FFF;
  border-radius: 5px;
  width: 250px;
  height: 46px;
  padding: 0;
  font-family: "Titillium Web", HelveticaNeue, Helvetica Neue, Helvetica,
  Arial, Lucida Grande, sans-serif;
  font-weight: 600;
  line-height: 1em;
  text-decoration: none;
  border: 0;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.spid-dropdown > li > a > img {
  height: 50px;
  padding: 10px 10px 10px 10px;
  border: 0;
  max-width: 100%;
}

.spid-dropdown > li > a::before {
  content: none;
  height: 0;
  width: 0;
}

.btn-icon {
  width: 29px;
}

.home-box-fornitore {
  padding: 10px;
  display: block;
  width: 100%;
  text-align: left;
}

.home-box-fornitore img {
  max-height: 29px;
  max-width: 250px;
  display: inline-block;
}

.home-box-fornitore:hover {
  background-color: #e8f2ff;
}

.login-container {
  max-width: 880px;
  padding: 2rem;
  font-family: "Titillium Web", titillium, HelveticaNeue, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
}

.tabs {
  list-style: none;
  display: flex;
  justify-content: start;
}

.tab button {
  padding: 1rem;
  border-bottom: 2px solid #efefef;
}

.tab button:hover, .tab.active button {
  border-bottom: 2px solid #06c;
}

.tab-content {
  padding: 1rem;
}
